export const BannerDefaultDuration = 30;

export const BannerEvents = {
    BannerLoaded: "bannerLoaded",
    BannerError: "bannerError"
} as const;

export const BannerQaCommentedOnBy = {
    Me: "ME",
    Any: "ANY",
    None: "NONE"
} as const;

export const BannerQaStatus = {
    Draft: "IN_DRAFT",
    InReview: "IN_QA",
    Approved: "QA_APPROVED",
    Rejected: "QA_REJECTED"
} as const;

export const BannerQaUserStatus = {
    None: "NONE",
    Approved: "QA_APPROVED",
    Rejected: "QA_REJECTED",
    INone: "INONE",
    IApproved: "IQA_APPROVED",
    IRejected: "IQA_REJECTED"
} as const;

export const BannerQaCommentedOnByLabel = {
    [BannerQaCommentedOnBy.Me]: "Me",
    [BannerQaCommentedOnBy.Any]: "Everybody",
    [BannerQaCommentedOnBy.None]: "None"
} as const;

export const BannerQaStatusLabel = {
    [BannerQaStatus.Draft]: "Draft",
    [BannerQaStatus.InReview]: "In review",
    [BannerQaStatus.Approved]: "Fully reviewed",
    [BannerQaStatus.Rejected]: "Changes required"
} as const;

export const BannerQaUserStatusLabel = {
    [BannerQaUserStatus.INone]: "Me",
    [BannerQaUserStatus.IApproved]: "Me",
    [BannerQaUserStatus.IRejected]: "Me",
    [BannerQaUserStatus.None]: "Everybody",
    [BannerQaUserStatus.Approved]: "Everybody",
    [BannerQaUserStatus.Rejected]: "Everybody"
} as const;

export const UserStatusUser = {
    Me: "ME",
    Any: "ANY"
} as const;

export const BannerQaUserStatusLabelFilterMap = {
    [BannerQaUserStatus.INone]: { user: UserStatusUser.Me, status: BannerQaUserStatus.None },
    [BannerQaUserStatus.IApproved]: { user: UserStatusUser.Me, status: BannerQaUserStatus.Approved },
    [BannerQaUserStatus.IRejected]: { user: UserStatusUser.Me, status: BannerQaUserStatus.Rejected },
    [BannerQaUserStatus.None]: { user: UserStatusUser.Any, status: BannerQaUserStatus.None },
    [BannerQaUserStatus.Approved]: { user: UserStatusUser.Any, status: BannerQaUserStatus.Approved },
    [BannerQaUserStatus.Rejected]: { user: UserStatusUser.Any, status: BannerQaUserStatus.Rejected }
};

export const BannerQaStatusFilter = {
    All: "all",
    ...BannerQaStatus
} as const;

export const BannerQaCommentedOnByFilter = {
    All: "all",
    ...BannerQaCommentedOnBy
} as const;

export const BannerQaUserStatusFilter = {
    All: "all",
    ...BannerQaUserStatus
} as const;

export const BannerQaCommentedOnByFilterLabel = {
    [BannerQaCommentedOnByFilter.All]: "All",
    ...BannerQaCommentedOnByLabel
} as const;

export const BannerQaStatusFilterLabel = {
    [BannerQaStatusFilter.All]: "All",
    ...BannerQaStatusLabel
} as const;

export const BannerQaUserStatusFilterLabel = {
    [BannerQaUserStatusFilter.All]: "All",
    ...BannerQaUserStatusLabel
} as const;
